import {
  FETCH_INITIAL_DATA,
  FETCH_INITIAL_DATA_SUCCESS,
  FETCHING_ERROR,
  SET_COMPANY_CODES_FILTER,
  UNSET_COMPANY_CODES_FILTER,
  FETCH_PROVISION_DATA,
  FETCH_PROVISION_DATA_SUCCESS,
  SELECT_COMPANY_CODE,
  SELECT_PERIOD,
  FETCH_TAX_YEARS,
  FETCH_TAX_YEARS_SUCCESS,
  SELECT_TAX_YEAR,
  SELECT_BOOK_TYPE,
  FETCH_BOOK_TYPES_STARTED,
  FETCH_BOOK_TYPES_SUCCESS,
  FETCH_BOOK_TYPES_FAILURE,
  FETCH_COMPANY_CODE_DETAILS,
  FETCH_COMPANY_CODE_DETAILS_SUCCESS,
  FETCH_CONNECTIONS_SUCCESS,
  FETCH_CONNECTIONS_BY_TYPE_SUCCESS,
  SELECT_CONNECTION,
  SELECT_CONNECTION_BY_TYPE,
  FETCH_PROVISIONS,
  FETCH_PROVISIONS_SUCCESS,
  FETCH_PROVISIONS_FAILURE,
  SHOW_ALERT,
  HIDE_ALERT,
  FETCH_PROVISION_DATA_FAILURE,
  SELECT_REPORTING_CURRENCY_CODE,
  FETCH_COUNTRY_TAX_TYPE_DESCRIPTIONS,
  FETCH_COUNTRY_TAX_TYPE_DESCRIPTIONS_SUCCESS,
  FETCH_COUNTRY_TAX_TYPE_DESCRIPTIONS_FAILURE,
  FETCH_CATEGORIES,
  FETCH_PERIODS,
  FETCH_PERIODS_SUCCESS,
  FETCH_CALCULATION_ID,
  FETCH_CALCULATION_ID_SUCCESS,
  FETCH_CALCULATION_ID_FAILURE,
  SELECT_CALCULATION,
  FETCH_USER_CLIENTS_LIST_SUCCESS,
} from './types';

import {
  UPLOAD_TRIAL_BALANCE_FILE,
} from '../../provisionPage/trialBalanceTab/store/types';

import {
  CALCULATE_PROVISION,
  CALCULATE_PROVISION_SUCCESS,
} from '../../provisionPage/store/types';

import {
  FETCH_COUNTRY_TAX_TYPES,
  FETCH_COUNTRY_TAX_TYPES_SUCCESS,
  FETCH_TAX_ENTRIES,
  FETCH_TAX_ENTRIES_SUCCESS,
  FETCH_TAX_ENTRY_DATA,
  FETCH_TAX_ENTRY_DATA_SUCCESS,
} from '../../balanceSheetManagement/store/types';

import { FETCH_TAX_EXPENSE_REPORT } from '../../reports/viewTaxExpensePage/store/types';

import { LOGOUT_SUCCESS } from '../../userData/store/types';

import initialState from './initialState';
import { fetchReducerFactory } from './fetchFactory';

const fetchReducer = fetchReducerFactory({
  [FETCH_CATEGORIES]: 'Categories',
}, initialState);

function sharedReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PROVISION_DATA:
      return {
        ...state,
        fetchingInitialProvisionData: action.fetchingInitialProvisionData,
        fetchingPriovisionData: true,
        isError: false,
        errorMessage: null,
      };
    case FETCH_INITIAL_DATA:
    case CALCULATE_PROVISION:
    case UPLOAD_TRIAL_BALANCE_FILE:
    case FETCH_TAX_YEARS:
    case FETCH_COUNTRY_TAX_TYPES:
    case FETCH_TAX_ENTRIES:
    case FETCH_TAX_ENTRY_DATA:
    case FETCH_COMPANY_CODE_DETAILS:
      return {
        ...state,
        isError: false,
        errorMessage: null,
      };
    case FETCH_PERIODS:
      return {
        ...state,
        isError: false,
        errorMessage: null,
        isInitialDataLoaded: false,
      };
    case FETCH_INITIAL_DATA_SUCCESS: {
      const activeClient = action.clients.find(client => client.clientId === action.user.lastClientId);

      return {
        ...state,
        featureFlags: activeClient?.featureFlags,
        istClientId: activeClient?.istClientId,
        app: action.app,
        companyCodes: action.companyCodes,
        periods: action.periods,
        currentPeriod: action.currentPeriod,
        period: action.period,
        isError: false,
        errorMessage: null,
        reportingCurrencyCodes: action.reportingCurrencyCodes,
        reportingCurrencyCode: action.reportingCurrencyCode,
        isInitialDataLoaded: true,
        taxYears: action.taxYears.taxYears,
        yearStartPeriod: action.yearStartPeriod,
      };
    }
    case FETCH_PROVISIONS:
      return {
        ...state,
        isFetchingCompanyCodes: true,
      };
    case FETCH_PROVISIONS_SUCCESS:
      return {
        ...state,
        companyCodes: action.companyCodes,
        isFetchingCompanyCodes: false,
      };
    case FETCH_PROVISIONS_FAILURE:
      return {
        ...state,
        isFetchingCompanyCodes: false,
      };
    case FETCHING_ERROR:
      return {
        ...state,
        isError: true,
        errorMessage: action.errorMessage,
      };
    case CALCULATE_PROVISION_SUCCESS:
    case FETCH_PROVISION_DATA_SUCCESS: {
      const companyCodeIndex = state.companyCodes.findIndex(
        companyCode => companyCode.cc === action.provisionData.general.companyCode
      );
      const companyCode = state.companyCodes[companyCodeIndex];

      const companyCodeUpdated = {
        ...companyCode,
        status: action.provisionData.general.statusName,
        lastUpdated: action.provisionData.general.updatedOn,
      };

      return {
        ...state,
        fetchingInitialProvisionData: false,
        fetchingPriovisionData: false,
        isError: false,
        errorMessage: null,
        provisionfunctionalCurrency: action.provisionData.general.functionalCurrency,
        companyCodes: [
          ...state.companyCodes.slice(0, companyCodeIndex),
          companyCodeUpdated,
          ...state.companyCodes.slice(companyCodeIndex + 1),
        ],
      };
    }
    case FETCH_PROVISION_DATA_FAILURE:
      return {
        ...state,
        fetchingInitialProvisionData: false,
        fetchingPriovisionData: false,
      };
    case FETCH_COUNTRY_TAX_TYPES_SUCCESS:
    case FETCH_TAX_ENTRIES_SUCCESS:
    case FETCH_TAX_ENTRY_DATA_SUCCESS:
    case FETCH_COMPANY_CODE_DETAILS_SUCCESS:
      return {
        ...state,
        isError: false,
        errorMessage: null,
      };
    case SELECT_COMPANY_CODE:
      return {
        ...state,
        companyCode: action.companyCode || null,
      };
    case SELECT_PERIOD:
      return {
        ...state,
        period: action.period,
      };
    case SET_COMPANY_CODES_FILTER:
      return {
        ...state,
        companyCodesFilter: action.filter,
      };
    case UNSET_COMPANY_CODES_FILTER:
      return {
        ...state,
        companyCodesFilter: '',
      };
    case FETCH_TAX_YEARS_SUCCESS:
      return {
        ...state,
        taxYears: action.taxYears,
        isError: false,
        errorMessage: null,
      };
    case FETCH_PERIODS_SUCCESS:
      return {
        ...state,
        periods: action.periods,
        currentPeriod: action.currentPeriod,
        isInitialDataLoaded: true,
      };
    case FETCH_USER_CLIENTS_LIST_SUCCESS: {
      const activeClient = action.clients.clients.find(
        client => client.clientId === action.lastClientId
      );
      return {
        ...state,
        featureFlags: activeClient?.featureFlags || state.featureFlags,
      };
    }
    case SELECT_TAX_YEAR:
      return {
        ...state,
        taxYear: action.taxYear,
      };
    case SELECT_BOOK_TYPE:
      return {
        ...state,
        bookType: action.bookType,
      };
    case LOGOUT_SUCCESS:
      return {
        ...initialState,
      };
    case FETCH_CONNECTIONS_SUCCESS:
      return {
        ...state,
        connections: action.connections,
        connection: action.connection,
      };
    case FETCH_CONNECTIONS_BY_TYPE_SUCCESS:
      return {
        ...state,
        connectionsByType: action.connectionsByType,
        connectionByType: action.connectionByType,
      };
    case SELECT_CONNECTION:
      return {
        ...state,
        connection: action.connection,
      };
    case SELECT_CONNECTION_BY_TYPE:
      return {
        ...state,
        connectionByType: action.connectionByType,
      };
    case SHOW_ALERT:
      return {
        ...state,
        alert: {
          show: true,
          content: action.content,
          alertType: action.alertType,
        },
      };
    case HIDE_ALERT:
      return {
        ...state,
        alert: {
          show: false,
          content: '',
          alertType: '',
        },
      };
    case SELECT_REPORTING_CURRENCY_CODE:
    case FETCH_TAX_EXPENSE_REPORT:
      return {
        ...state,
        reportingCurrencyCode: action.reportingCurrencyCode,
      };
    case FETCH_BOOK_TYPES_STARTED:
      return {
        ...state,
        bookTypesFetching: true,
        bookTypes: [],
      };
    case FETCH_BOOK_TYPES_SUCCESS:
      return {
        ...state,
        bookTypesFetching: false,
        bookTypes: action.bookTypes,
      };
    case FETCH_BOOK_TYPES_FAILURE:
      return {
        ...state,
        bookTypesFetching: false,
        bookTypes: [],
      };
    case FETCH_COUNTRY_TAX_TYPE_DESCRIPTIONS:
      return {
        ...state,
        isFetchingCountryTaxTypeDescriptions: true,
      };
    case FETCH_COUNTRY_TAX_TYPE_DESCRIPTIONS_SUCCESS:
      return {
        ...state,
        countryTaxTypeDescriptions: action.countryTaxTypeDescriptions,
        isFetchingCountryTaxTypeDescriptions: false,
      };
    case FETCH_COUNTRY_TAX_TYPE_DESCRIPTIONS_FAILURE:
      return {
        ...state,
        countryTaxTypeDescriptions: null,
        isFetchingCountryTaxTypeDescriptions: false,
      };
    case FETCH_CALCULATION_ID:
      return {
        ...state,
        calculationIdList: [],
        calculationIdSelected: {},
        isFetchingCalculationId: true,
      };
    case FETCH_CALCULATION_ID_SUCCESS:
      return {
        ...state,
        calculationIdList: action.calculationIdList,
        isFetchingCalculationId: false,
      };
    case FETCH_CALCULATION_ID_FAILURE:
      return {
        ...state,
        calculationIdList: [],
        isFetchingCalculationId: false,
      };
    case SELECT_CALCULATION:
      return {
        ...state,
        calculationIdSelected: action.calculationIdSelected,
      };
    default:
      return fetchReducer(state, action);
  }
}

export default sharedReducer;
